<template>
  <div class="page h-100 d-flex flex-column">
    <b-jumbotron :class="{ 'mb-0': form }" fluid>
      <div class="d-flex align-items-center">
        <h1 class="h3 mr-auto m-1">Głosowanie</h1>
        <router-link v-if="form" :to="{ name: 'glosowanie-lista' }" class="btn btn-primary">
          Wróć do listy
        </router-link>
        <router-link v-if="!form" :to="{ name: 'glosowanie', params: {id: 'test'} }" class="btn btn-primary">
          TEST
        </router-link>
      </div>
    </b-jumbotron>

    <div class="flex-grow-1" :class="{ container: !form }">
      <b-list-group class="mb-3" v-if="!form">
        <b-list-group-item v-for="(item, id) in forms" v-if="id !== 'test'"
                           :to="{ name: 'glosowanie', params: { id } }"
                           active-class="active"
                           class="h4 m-0 d-flex align-items-center"
        >
          <b-badge variant="primary" pill class="mr-3">{{id}}</b-badge>
          <span v-html="item.title"></span>
        </b-list-group-item>
      </b-list-group>

      <div class="iframe-wrapper flex-grow-1" v-if="form && form.iframe">
        <iframe :src="form.iframe" frameborder="0" marginheight="0" marginwidth="0"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
const forms = {
  test: {
    title: 'Głosowanie testowe',
    iframe: 'https://docs.google.com/forms/d/e/1FAIpQLSeK-HtwxrHEsHttVYBiN3TfAqGx-Icclb6GUOBh1jXJR2baSA/viewform?embedded=true'
  },
  '1': {
    title: 'Głosowanie w sprawie <b class="text-success">przyjęcia porządku obrad</b>',
    iframe:
      'https://docs.google.com/forms/d/e/1FAIpQLSfnDF_TMYVavjkMy0uKT0zYnEpiK-GY1K3YN1YRyBKK-XgKOg/viewform?embedded=true',
  },
  '2': {
    title: 'Głosowanie w sprawie zatwierdzenia <b class="text-success">sprawozdania Społecznego Komitetu Parkingowego</b>',
    iframe: 'https://docs.google.com/forms/d/e/1FAIpQLSdmhxM6vK33W35gwqNGlQffPDFs4M0GmGk_ABGtu8ymoxScPg/viewform?embedded=true',
  },
  '3': {
    title: 'Głosowanie w sprawie zatwierdzenia <b class="text-success">Regulaminu Parkingu Społecznego</b>',
    iframe: 'https://docs.google.com/forms/d/e/1FAIpQLSewrZ21ykzUrk3HznQfyGL4fZuzJMoZwZV7kXpJerA6tO586Q/viewform?embedded=true',
  },
  '4': {
    title: 'Głosowanie w sprawie udzielenia zgody na przeprowadzenie <b class="text-success">modernizacji bramy wjazdowej</b>',
    iframe: 'https://docs.google.com/forms/d/e/1FAIpQLSeDhh7T7IjlnJkPbOLts5jgOBOIfZuihOxKL2POrsgtu_oxBQ/viewform?embedded=true',
  },
  '5': {
    title: 'Głosowanie w sprawie <b class="text-success">utworzenia funduszu społecznego</b> na utrzymanie parkingu',
    iframe: 'https://docs.google.com/forms/d/e/1FAIpQLSfBu8zAyKLVZFHuKpOuS3BlHwq7z4BSG-LcsfQFyohpl0t0QA/viewform?embedded=true',
  },
  '6': {
    title: 'Głosowanie w sprawie <b class="text-success">wnoszenia innych opłat</b> naliczonych i wymaganych, ale nie wliczonych do czynszu przez Spółdzielnię',
    iframe: 'https://docs.google.com/forms/d/e/1FAIpQLSe6xjN4iKMC4pDeBQK3Co97qWtoaYlwsDv6OUS2UjwiGhcTWA/viewform?embedded=true',
  },
  '7': {
    title: 'Głosowanie w sprawie udzielenia zgody na przeprowadzenie <b class="text-success">modernizacji furtek</b>',
    iframe: 'https://docs.google.com/forms/d/e/1FAIpQLSe6OZgg7hMSzOd8hUx_HvFMxzUX5R9-Nie_qE0sjJ_z7qNDXw/viewform?embedded=true',
  },
  '8': {
    title: 'Głosowanie nad <b class="text-success">wnioskiem nr 1</b>',
    iframe: 'https://docs.google.com/forms/d/e/1FAIpQLScVy1RSed3wLy1w9O-0LKwliFfpPF9kFFpKp7CgP-rHog2P7w/viewform?embedded=true',
  },
  '9': {
    title: 'Głosowanie nad <b class="text-success">wnioskiem nr 2</b>',
    iframe: 'https://docs.google.com/forms/d/e/1FAIpQLSc6vR0wzEOjFVYJICwcvS1jm8GcmtKCTmjaNeQ7sGV38L-sow/viewform?embedded=true',
  },
  '10': {
    title: 'Głosowanie nad <b class="text-success">wnioskiem nr 3</b>',
    iframe: 'https://docs.google.com/forms/d/e/1FAIpQLSdZjukCkD7KtxeqDe03OkXerZh4jyhTzYPkmQITvV-HWd0tTA/viewform?embedded=true',
  },
  '11': {
    title: 'Głosowanie nad <b class="text-success">wnioskiem nr 4</b>',
    iframe: 'https://docs.google.com/forms/d/e/1FAIpQLScOjYBzn1ppDWZmnzi8M7A0xWasuJtlbeRd3Pv6l3MDqDOYrw/viewform?embedded=true',
  },
  '12': {
    title: 'Głosowanie nad <b class="text-success">wnioskiem nr 5</b>',
    iframe: 'https://docs.google.com/forms/d/e/1FAIpQLScaUshZ13kYiLcvaySjOarmIpd81EWe5GSqKDQc2fodPUYH9Q/viewform?embedded=true',
  },
  '13': {
    title: 'Głosowanie nad <b class="text-success">wnioskiem nr 6</b>',
    iframe: 'https://docs.google.com/forms/d/e/1FAIpQLSfb_BJ864FQ1gv2XdMue3qdW9oTuwacJ4k6a2cH-xpD1S3KlQ/viewform?embedded=true',
  },
  '14': {
    title: 'Głosowanie nad <b class="text-success">wnioskiem nr 7</b>',
    iframe: 'https://docs.google.com/forms/d/e/1FAIpQLSeGgKAG5VFuOxrLnGzJHfuiF7neELI1Byj9dHE-3XAr91ZkLQ/viewform?embedded=true',
  },
};

export default {
  name: 'glosowanie',
  data() {
    return {
      forms,
    };
  },
  computed: {
    form() {
      return forms[this.$route.params.id];
    },
  },
};
</script>

<style lang="scss">
.iframe-wrapper {
  position: relative;
  height: 100%;

  iframe {
    border: 0;
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
